// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".errorCard{display:flex;flex-direction:column;align-items:center;justify-content:center}.errorCard p{text-align:center}@media only screen and (max-width: 1280px){.errorCard .button-wrapper{display:flex;flex-direction:column}}", ""]);
// Exports
module.exports = exports;
